import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-1.5 rounded-full bg-accent-500" />
        <div>
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {icon ? (
              <i className={`${icon} text-accent-500`} aria-hidden="true" />
            ) : null}
            {title}
          </h2>
          {subtitle ? (
            <p className="mt-1 text-xs text-foreground-500 md:text-sm">
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
      {action}
      {moreTo ? (
        <Link
          to={moreTo}
          className="group flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-sm font-medium text-primary-700 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i
            className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5"
            aria-hidden="true"
          />
        </Link>
      ) : null}
    </div>
  );
}